import {
  removeFromLocalStorage,
  retrieveFromLocalStorage,
  saveInLocalStorage,
} from './storage';

const MILLISECONDS_IN_A_MINUTE = 1000 * 60;

const LAST_ACTIVITY_TIME_KEY = 'last-activity-time';

export function clearActivityTimer() {
  removeFromLocalStorage(LAST_ACTIVITY_TIME_KEY);
}

export function resetActivityTimer() {
  saveInLocalStorage(LAST_ACTIVITY_TIME_KEY, Date.now().toString(), {
    serialize: false,
  });
}

export function hasBeenInactiveForTooLong(maxIdleMinutes: number) {
  const lastActivityTimeString = retrieveFromLocalStorage<string>(
    LAST_ACTIVITY_TIME_KEY,
    {
      serialized: false,
    },
  );
  if (lastActivityTimeString == null) {
    return false;
  }
  const lastActivityTime = Number(lastActivityTimeString);

  if (isNaN(lastActivityTime)) {
    clearActivityTimer();
    return false;
  }

  const diffMinutes =
    (Date.now() - lastActivityTime) / MILLISECONDS_IN_A_MINUTE;

  return diffMinutes > maxIdleMinutes;
}
